module.exports = __webpack_public_path__ + "static/img/元生平台_bj@2x.fad95698.png";